type Props = {
  fill?: string;
  isBold?: boolean;
};
export const CryptoCoin: React.FC<Props> = ({ fill = "currentColor", isBold }) => (
  <>
    {isBold ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={11}
        height={12}
        fill="none"
      >
        <path
          fill={fill}
          d="M4.125.667c0-.369.308-.667.688-.667h1.375c.38 0 .687.298.687.667v10.666a.677.677 0 0 1-.688.667H4.813a.677.677 0 0 1-.687-.667V.667Z"
        />
        <path
          fill={fill}
          d="M.688 2.667A.677.677 0 0 1 0 2V.667C0 .298.308 0 .688 0h9.624c.38 0 .688.298.688.667V2a.677.677 0 0 1-.688.667H.688ZM1.375 6.667A.677.677 0 0 1 .687 6V4.667c0-.369.308-.667.688-.667h8.25c.38 0 .688.298.688.667V6a.677.677 0 0 1-.688.667h-8.25Z"
        />
      </svg>
    ) : (
      <svg
        width={10}
        height={10}
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.35487 0.555556C4.35487 0.248731 4.60761 3.59764e-07 4.91939 3.59764e-07H6.04842C6.36019 3.59764e-07 6.61294 0.248731 6.61294 0.555556V9.44444C6.61294 9.75127 6.36019 10 6.04842 10H4.91939C4.60761 10 4.35487 9.75127 4.35487 9.44444V0.555556Z"
          fill={fill}
        />
        <path
          d="M1.53229 2.22222C1.22052 2.22222 0.967774 1.97349 0.967773 1.66667L0.967773 0.555556C0.967773 0.248731 1.22052 3.49026e-07 1.53229 3.3578e-07L9.43552 0C9.74729 -1.32462e-08 10 0.248731 10 0.555555V1.66667C10 1.97349 9.74729 2.22222 9.43552 2.22222L1.53229 2.22222Z"
          fill={fill}
        />
        <path
          d="M2.09681 5.55556C1.78503 5.55556 1.53229 5.30683 1.53229 5V3.88889C1.53229 3.58206 1.78503 3.33333 2.09681 3.33333L8.871 3.33333C9.18277 3.33333 9.43552 3.58206 9.43552 3.88889V5C9.43552 5.30682 9.18277 5.55555 8.871 5.55556L2.09681 5.55556Z"
          fill={fill}
        />
      </svg>
    )}
  </>
);
